import { Invitation } from './invitation';

export class InvitationRequest {
  constructor(
    public resourceId: string,
    public issueImmediately: boolean,
    public invitations: Invitation[]
  ) {}

  customerId: string | null = null;
}
